import React from 'react';

const Payment = () => {
    return (
        <div>
            <h1>Payment system comming soon</h1>
        </div>
    );
};

export default Payment;